
<section id="footer" class="section7 ng-scope">
  <div class="container-fluid">
    <div class="row">
        <div class="col-md-3 col-xs-12 col-sm-12">
            <h1 class="vertical-text fnt-sze-38" style="color: #fff;">
                CONTACT US
            </h1>
        </div>
        <div class="col-md-3 col-xs-12 col-sm-12">
            <h1 class="contact-heading">Visit Us</h1>
            <p style="color: #fff" class="address">FTD India Private Limited<br>
            Block 2, 6th Floor, <br>
            My Home Hub, Hitech City, Madhapur, <br>
            Hyderabad, Telangana, India<br>
            </p>   
        </div>
       <div class="col-md-3 col-xs-12 col-sm-12">
            <h1 class="contact-heading">Mail Us</h1>
            <p style="color: #fff" class="customer-text">
                <a href="mailto:careers@ftdi.com" style="color: #fff;font-family: 'MaisonNeueMono', sans-serif;font-size: 14px;">careers@ftdi.com</a>
            </p>
        </div>
       <div class="col-md-3 col-xs-12 col-sm-12">
            <h1 class="contact-heading">Call Us</h1>
            <p style="color: #fff" class="customer-text">
            <a href="tel:+91 40 42001104">+91 40 42001104</a>
            </p>    
        </div>  
      </div> 
      
       <div class="row" style="padding: 4% 0 0%;">
        <div class="col-md-12">
            <p class="copyright">© FTD All Rights Reserved Powered By
              <a target="_blank" href="https://zwayam.com">
                <img src="assets/zwa.png" loading="lazy" alt="Copyright" width="87" height="30">
              </a>
            </p>
        </div>
      </div>
      
  </div>
  
</section>